import { alpha } from "@mui/material";
function createLightPalette(tidalColors) {
  return {
    accent: {
      contrastText: tidalColors.seafoamTeal[900],
      dark: tidalColors.seafoamTeal[700],
      light: tidalColors.seafoamTeal[400],
      main: tidalColors.seafoamTeal[500]
    },
    accentNeutral: {
      contrastText: tidalColors.seafoamTeal[900],
      dark: tidalColors.seafoamTeal[400],
      light: tidalColors.seafoamTeal[200],
      main: tidalColors.seafoamTeal[300]
    },
    accentSoft: {
      contrastText: tidalColors.seafoamTeal[800],
      dark: tidalColors.seafoamTeal[200],
      light: tidalColors.seafoamTeal[50],
      main: tidalColors.seafoamTeal[100]
    },
    // ---------------------------------------------------------------------
    // Others
    // ---------------------------------------------------------------------
    action: {
      activatedOpacity: 0.56,
      active: alpha("#091B2A", 0.56),
      disabled: alpha("#091B2A", 0.38),
      disabledBackground: alpha("#091B2A", 0.12),
      disabledOpacity: 0.38,
      focus: alpha("#091B2A", 0.12),
      focusOpacity: 0.12,
      hover: alpha("#091B2A", 0.04),
      hoverOpacity: 0.04,
      selected: alpha("#091B2A", 0.08),
      selectedOpacity: 0.08
    },
    background: {
      default: tidalColors.cloudGray[100],
      default2: tidalColors.cloudGray[200],
      default3: tidalColors.cloudGray[300],
      paper: tidalColors.cloudGray[50]
    },
    divider: tidalColors.slateBlueGray[100],
    error: {
      contrastText: "#FFFFFF",
      dark: tidalColors.lobsterRed[600],
      light: tidalColors.lobsterRed[400],
      main: tidalColors.lobsterRed[500]
    },
    // ---------------------------------------------------------------------
    // Neutral Semantic
    // ---------------------------------------------------------------------
    errorNeutral: {
      contrastText: tidalColors.lobsterRed[900],
      dark: tidalColors.lobsterRed[400],
      light: tidalColors.lobsterRed[200],
      main: tidalColors.lobsterRed[300]
    },
    // ---------------------------------------------------------------------
    // Neutral Semantic
    // ---------------------------------------------------------------------
    errorSoft: {
      contrastText: tidalColors.lobsterRed[800],
      dark: tidalColors.lobsterRed[200],
      light: tidalColors.lobsterRed[50],
      main: tidalColors.lobsterRed[100]
    },
    grey: {
      A100: "#D5D5D5",
      A200: "#AAAAAA",
      A400: "#616161",
      A700: "#303030"
    },
    info: {
      contrastText: "#112A47",
      dark: tidalColors.oceanBlue.A700,
      light: tidalColors.oceanBlue.A100,
      main: tidalColors.oceanBlue.A200
    },
    infoNeutral: {
      contrastText: "#112A47",
      dark: tidalColors.oceanBlue.A100,
      light: "#A7D0FF",
      main: "#84BDFF"
    },
    infoSoft: {
      contrastText: "#112A47",
      dark: "#A7D0FF",
      light: "#ECF5FF",
      main: "#DBECFF"
    },
    // ---------------------------------------------------------------------
    // Default Semantic
    // ---------------------------------------------------------------------
    primary: {
      contrastText: "#FFFFFF",
      dark: tidalColors.oceanBlue[700],
      light: tidalColors.oceanBlue[400],
      main: tidalColors.oceanBlue[500]
    },
    secondary: {
      contrastText: tidalColors.oceanBlue[800],
      dark: tidalColors.oceanBlue[200],
      light: tidalColors.oceanBlue[50],
      main: tidalColors.oceanBlue[100]
    },
    success: {
      contrastText: tidalColors.jadeGreen[900],
      dark: tidalColors.jadeGreen[700],
      light: tidalColors.jadeGreen[400],
      main: tidalColors.jadeGreen[500]
    },
    successNeutral: {
      contrastText: tidalColors.jadeGreen[900],
      dark: tidalColors.jadeGreen[400],
      light: tidalColors.jadeGreen[200],
      main: tidalColors.jadeGreen[300]
    },
    successSoft: {
      contrastText: tidalColors.jadeGreen[900],
      dark: tidalColors.jadeGreen[200],
      light: tidalColors.jadeGreen[50],
      main: tidalColors.jadeGreen[100]
    },
    text: {
      contrastText: tidalColors.slateBlueGray[900],
      disabled: alpha(tidalColors.slateBlueGray[900], 0.55),
      primary: alpha(tidalColors.slateBlueGray[900], 0.85),
      secondary: alpha(tidalColors.slateBlueGray[900], 0.7)
    },
    tidalColors,
    warning: {
      contrastText: tidalColors.sunnyYellow[900],
      dark: tidalColors.sunnyYellow[800],
      light: tidalColors.sunnyYellow[400],
      main: tidalColors.sunnyYellow[500]
    },
    warningNeutral: {
      contrastText: tidalColors.sunnyYellow[900],
      dark: tidalColors.sunnyYellow[400],
      light: tidalColors.sunnyYellow[200],
      main: tidalColors.sunnyYellow[300]
    },
    warningSoft: {
      contrastText: tidalColors.sunnyYellow[900],
      dark: tidalColors.sunnyYellow[200],
      light: tidalColors.sunnyYellow[50],
      main: tidalColors.sunnyYellow[100]
    },
    workwaveBlue: "#002D5C"
  };
}
export {
  createLightPalette
};
//# sourceMappingURL=createLightPalette.js.map
